import {call, put, select, takeLatest} from 'redux-saga/effects';
import TaxProfileAction from '../actions/TaxProfileActions';
import TaxProfileApi from '../apis/TaxProfileApi';
import { createSaga } from '../utils/sagaUtils';

/**
 * Gets user's tax profile
 */
function* getTaxProfile(action) {
    yield createSaga(
        action,
        TaxProfileApi.getTaxRecord,
        TaxProfileAction.getTaxProfileSuccess,
        TaxProfileAction.getTaxProfileFailed
    );
    yield put(TaxProfileAction.getTaxDocuments());
}

/**
 * Updates a user's tax profile
 */
function* updateTaxProfile(action) {
    yield createSaga(
        action,
        TaxProfileApi.updateTaxRecord,
        TaxProfileAction.updateTaxProfileSuccess,
        TaxProfileAction.updateTaxProfileFailed
    );
}

/**
 * Forces an update to be pulled from Tax Identity
 */
function* pullTaxProfile(action) {
    yield createSaga(
        action,
        TaxProfileApi.pullTaxRecord,
        TaxProfileAction.pullTaxProfileSuccess,
        TaxProfileAction.pullTaxProfileFailed,
        () => ({})
    );
}

/**
 * Gets URL for retake interview flow
 */
function* getInterview(action) {
    yield createSaga(
        action,
        TaxProfileApi.getInterview,
        TaxProfileAction.getInterviewSuccess,
        TaxProfileAction.getInterviewFailed,
        (payload) => ({locale: payload})
    );
}

function* traceTaxInterview() {
    try {
        yield call(TaxProfileApi.traceTakeInterview);
    } catch (e) {
        console.info('Failed to trace take interview', e);
    }
}

function* getAccountStatus(action) {
    yield createSaga(
        action,
        TaxProfileApi.getAccountStatus,
        TaxProfileAction.getAccountStatusSuccess,
        TaxProfileAction.getAccountStatusFailed,
        () => ({})
    );
}

function* getTaxRetakeAvailable(action) {
    yield createSaga(
        action,
        TaxProfileApi.getTaxRetakeAvailable,
        TaxProfileAction.getTaxRetakeAvailableSuccess,
        TaxProfileAction.getTaxRetakeAvailableFailed,
        () => ({})
    );
}

/**
 * Gets Consent URL for sign interview flow
 */
function* getConsentInterview(action) {
    yield createSaga(
        action,
        TaxProfileApi.getConsentInterview,
        TaxProfileAction.getConsentTaxInterviewSuccess,
        TaxProfileAction.getConsentTaxInterviewFailed,
        (payload) => ({locale: payload.locale, prizeId: payload.prizeId})
    );
}

function* getTaxDocuments() {
    try {
        const resp = yield call(TaxProfileApi.getTaxDocuments);
        yield put(TaxProfileAction.getTaxDocumentsSuccess(resp));
    } catch (e) {
        const taxDocReqCount = yield select((state) => {
            return state.getIn(['taxProfile', 'taxDocReqCount'], 0);
        });
        if (taxDocReqCount < 2) {
            yield put(TaxProfileAction.setTaxDocReqCount(taxDocReqCount + 1));
            yield put(TaxProfileAction.getTaxDocuments());
        }
        console.info('Failed to get account status', e);
    }
}

function* TaxProfileSaga() {
    yield takeLatest(TaxProfileAction.TYPES.GET_TAX_PROFILE, getTaxProfile);
    yield takeLatest(TaxProfileAction.TYPES.UPDATE_TAX_PROFILE, updateTaxProfile);
    yield takeLatest(TaxProfileAction.TYPES.PULL_TAX_PROFILE, pullTaxProfile);
    yield takeLatest(TaxProfileAction.TYPES.GET_INTERVIEW, getInterview);
    yield takeLatest(TaxProfileAction.TYPES.TRACE_TAKE_INTERVIEW, traceTaxInterview);
    yield takeLatest(TaxProfileAction.TYPES.GET_PAYOUT_ACCOUNT_STATUS, getAccountStatus);
    yield takeLatest(TaxProfileAction.TYPES.GET_TAX_DOCUMENTS, getTaxDocuments);
    yield takeLatest(TaxProfileAction.TYPES.GET_RETAKE_AVAILABLE, getTaxRetakeAvailable);
    yield takeLatest(TaxProfileAction.TYPES.GET_CONSENT_INTERVIEW, getConsentInterview);
}

export default TaxProfileSaga;
